import { NumberRange } from '@blueprintjs/core';
import { isNaN, isNil } from 'lodash';

export function parseRange(serialisedRange: string | null) {
  if (serialisedRange == null) {
    return undefined;
  }

  const result = serialisedRange
    .split(',')
    .map(x => Number(x))
    .slice(0, 2)
    .filter(x => !isNil(x) && !isNaN(x));

  if (result.length === 0) {
    return undefined;
  }

  return result as NumberRange;
}

export function parsePriceRange(serialisedRange: string | null) {
  if (serialisedRange == null) {
    return undefined;
  }

  const result = serialisedRange.split(',').map(x => {
    if (!x) {
      return undefined;
    }
    return Number(x);
  });

  if (result.length === 0) {
    return undefined;
  }

  return result;
}
